// extracted by mini-css-extract-plugin
export default {"icons":"HeaderRightButton_icons__r3acL","desktopIcons":"HeaderRightButton_desktopIcons__yfefd","mobileIcons":"HeaderRightButton_mobileIcons__toAYk"};